import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/context/LanguageContext";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import LandingPage from "@/pages/LandingPage";
import BlogPage from "@/pages/BlogPage";
import BlogArticlePage from "@/pages/BlogArticlePage";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import LogoDownloadPage from "@/pages/LogoDownloadPage";
import DemoPage from "@/pages/DemoPage";
import DemosPage from "@/pages/DemosPage";
import AdvisorPage from "@/pages/AdvisorPage";
import AuthPage from "@/pages/AuthPage";
import ClientPortal from "@/pages/ClientPortal";
import FloatingChat from "@/components/FloatingChat";

const ChatWrapper = () => {
  const location = useLocation();
  const hideOn = ["/admin", "/asesor", "/portal"];
  const shouldHide = hideOn.some((p) => location.pathname.startsWith(p));
  if (shouldHide) return null;
  return <FloatingChat />;
};

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen bg-[#02040a] flex items-center justify-center"><div className="w-8 h-8 border-2 border-[#3b82f6] border-t-transparent rounded-full animate-spin" /></div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

function App() {
  return (
    <HelmetProvider>
      <LanguageProvider>
        <AuthProvider>
          <div className="App">
            <BrowserRouter>
              <Routes>
                <Route path="/" element={<LandingPage />} />
                <Route path="/demo" element={<DemoPage />} />
                <Route path="/demos" element={<DemosPage />} />
                <Route path="/asesor" element={<AdvisorPage />} />
                <Route path="/blog" element={<BlogPage />} />
                <Route path="/blog/:slug" element={<BlogArticlePage />} />
                <Route path="/admin/*" element={<AdminDashboard />} />
                <Route path="/logo" element={<LogoDownloadPage />} />
                <Route path="/login" element={<AuthPage />} />
                <Route path="/portal" element={<ProtectedRoute><ClientPortal /></ProtectedRoute>} />
              </Routes>
              <ChatWrapper />
            </BrowserRouter>
            <Toaster position="top-right" richColors />
            <div className="noise-overlay" />
          </div>
        </AuthProvider>
      </LanguageProvider>
    </HelmetProvider>
  );
}

export default App;
